import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAuth } from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { FUNCTIONS_REGION } from './functionsRegion';
import { getMessaging, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyBaPV4YzG6IfzsNN-iuLHBPhYF2yakSWkE",
  authDomain: "mt-app-backend.firebaseapp.com",
  projectId: "mt-app-backend",
  storageBucket: "mt-app-backend.firebasestorage.app",
  messagingSenderId: "615386169185",
  appId: "1:615386169185:web:68d2ed0dd2d51a0370cf20",
  measurementId: "G-E4S339E7SN"
};

const app = initializeApp(firebaseConfig);

// App Check: attest that requests come from the real web app (reCAPTCHA v3).
// Gated on the site key so localhost and CI run unverified until the key is
// created in the App Check console - enforcement is off there, so unverified
// only means it shows in the metrics. Must run before the first
// Firestore/Functions/Storage call or those requests go out tokenless.
// In development the debug flag makes the SDK mint a debug token and log it
// to the browser console; register it under App Check -> Apps -> Manage
// debug tokens instead of letting reCAPTCHA score localhost traffic.
const appCheckSiteKey = process.env.REACT_APP_APPCHECK_RECAPTCHA_SITE_KEY;
if (appCheckSiteKey) {
  if (process.env.NODE_ENV === 'development') {
    (window as { FIREBASE_APPCHECK_DEBUG_TOKEN?: boolean } & Window).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

export const auth = getAuth(app);

// Initialize Firestore - auto-detect tries WebSocket first, falls back to long polling if blocked
export const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
});

export const storage = getStorage(app);

// Passing the region explicitly matters: a bare getFunctions(app) silently
// pins the SDK default (us-central1), which stops matching the deployment
// the moment the functions move region.
export const functions = getFunctions(app, FUNCTIONS_REGION);

// Initialize messaging with support check for web push notifications
export const messaging = (async () => {
  try {
    const supported = await isSupported();
    if (supported) {
      return getMessaging(app);
    }
    console.warn('FCM is not supported in this browser');
    return null;
  } catch (error) {
    console.warn('Error initializing FCM:', error);
    return null;
  }
})();

// Performance Monitoring is deliberately NOT initialised here - see
// ./performance.ts. It is loaded dynamically from index.tsx so that the SDK
// (and its ESM-only web-vitals dependency) stays out of both the entry bundle
// and every Jest suite that transitively imports this module.

// Remove all emulator connections - now using real Firebase services
// No longer connecting to emulators

export default app;